import React from 'react';
import * as api from '../../../../api';
import './SchoolVideo.css';
import { PATH } from '../../../../constants';

// todo - consider final folder hierarchy + name

const SchoolVideo = ({ videoId, videoActive, videoData, onPlayClick }) => (
  <div className="part school-video-frame">
    {!videoActive &&
    <button
      className="video-start-btn"
      onClick={() => {
        onPlayClick(videoId);
      }}
    >
      <img
        className="thumb"
        src={api.videoImageUrl(videoData)}
        alt=""
      />
      <img
        className="ico"
        src={`${PATH.IMG}ico/ico-play.png`}
        alt="Přehrát"
      />
    </button>
    }
    {videoActive &&
    <iframe
      className="video-frame"
      title="Video"
      src={api.getVideoSource(videoData)}
      allowFullScreen
    />
    }
  </div>
);

export default SchoolVideo;




// WEBPACK FOOTER //
// ./src/components/App/SchoolDetail/SchoolVideo/SchoolVideo.js